import { EventBus } from 'quasar';
import { defineBoot } from '#q-app/wrappers';

export const bus = new EventBus();

export default defineBoot(({ app }) => {
  app.config.globalProperties.$bus = bus;
});
